import {globalStore} from '../../main.js'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
  
export default {
  name: 'login',
  components: {
    PulseLoader
  },
  props: ['token'],
  data() {
    return {
      showSpinner: false,
      key: this.$props.token,
      formSubmitted: false,
      loginFailed: false,      
      credentials: {
        UserName: null,
        Password: null
      },
      user601: false
    }
  },
  mounted: function () {
  this.$nextTick(function () {
      if (this.key) {
        this.$session.start();
        this.$session.set('jwt', this.key);
        this.getCurrentUser();
      }
    })
  },
  methods: {
    forgotPassword: function(event) {
        event.preventDefault();
        this.$router.push('forgotPassword');
    },
    proceed: function(event) {
      event.preventDefault();
      this.formSubmitted = true;
      
      if (this.formValid)  {
        this.showSpinner = true;
        this.user601 = false;
        const apiUrl = globalStore.host + 'login';
        this.$axios.post(apiUrl, 'userName=' + encodeURIComponent(this.credentials.UserName) + '&password=' + encodeURIComponent(this.credentials.Password) + '&grant_type=password', {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}).then(response => {
            if (response.status === 200 && 'access_token' in response.data){
              this.$session.start();
              this.$session.set('jwt', response.data.access_token);
              this.getCurrentUser();
            }
          })
          .catch(err => {
            this.showSpinner = false;
            if (err.response && err.response.data.error == 'not_allow_601') {
              this.user601 = true;
            } else {
              this.loginFailed = true;
            }
            return err;
          });
         }
    },
    getCurrentUser: function() {
        const apiUrl = globalStore.host + 'Current';
        this.$axios.get(apiUrl, { headers: {'Authorization': 'Bearer ' + this.$session.get('jwt')}}).then(response => {
            this.showSpinner = false;
            if (response.status === 200){
              var user = response.data;
              this.$session.set('user', user);
              window.user.IsLoggedIn = true;
              
              globalStore.checkRoles();
              globalStore.checkCurrentUserAvatar();
              globalStore.useCurrentUserLocale();


              if(globalStore.isCurrentUserAdmin || globalStore.isCurrentUserMMPWM){
                this.$router.push('/dashboard/userslist');
                return;
              } 
              
              if (this.key){
                this.$router.push('/dashboard/changePassword');
                return;
              } else {
                this.$router.push('/dashboard');
                return;
              }
            }
          })
          .catch(err => {
            this.showSpinner = false;
            if(err.response.status === 401) {
              this.$session.destroy();
              this.$router.push('login')
            }
            this.loginFailed = true ;
            return err;
          });
      },
      closeLoginFilled: function(event) {
          event.preventDefault();
          this.loginFilled = true;
      }
  },
  computed: {
    loginValid: function() {
      return !globalStore.emailInBlackList(this.credentials.UserName);
    },
    loginFilled: function() {
      return !!this.credentials.UserName;
    },
    passwordFilled: function() {
      return !!this.credentials.Password;
    },
    requiredError: function() {
      return !this.formValid && this.formSubmited;
    },
    formValid: function() {
      return this.formSubmitted && this.loginFilled && this.passwordFilled && this.loginValid;
    },
    labels: function() {
        return globalStore.culture.strings.Login;
    }
  },
  beforeCreate: function () {
    if (this.$session.exists()){
      this.$router.push('/dashboard');  
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.js